import React from "react";
import { Navigate } from "react-router-dom";
import { hasAdminAccess } from "./utils/authz";

/**
 * allowedForStaffOnly: boolean (si es true, solo usuarios con acceso admin pueden ver la ruta)
 * user: objeto de usuario
 */
export default function PrivateRoute({ user, children, allowedForStaffOnly = false }) {
  if (!user) {
    // Si no hay usuario autenticado, redirige a la raíz (muestra login)
    return <Navigate to="/" replace />;
  }

  // Si la ruta es solo para admin y el usuario no tiene acceso admin, redirige a su perfil
  if (allowedForStaffOnly && !hasAdminAccess(user)) {
    return <Navigate to="/app/profile" replace />;
  }

  return children;
}
